import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {OnboardingStatus} from '../../../onboarding/onboarding.model';
import {RequestStatus} from '../workflow-v2.interface';

@Component({
  selector: 'gp-workflow-status',
  templateUrl: './workflow-status.component.html',
  styleUrls: ['./workflow-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowStatusComponent {

  @Input()
  public status: RequestStatus | OnboardingStatus;
}
